module.exports = __webpack_public_path__ + "img/logo.86e7ee33.png";